import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAssetFeatureOptionSaga } from "src/store/asset-features-options/saga";
import * as Yup from "yup";
import { SectorDto } from "src/store/system/type";
import { getSectors } from "src/store/system/saga";
import { DamageDefinitionPicklistOptionDto } from "src/store/contract-damage-definition/type";

const DamageOptionEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: DamageDefinitionPicklistOptionDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.DamageOption.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          PicklistOptionName: data.PicklistOptionName,
          DamageDefinitionId: data.DamageDefinitionId,
          Translates: data.Translates,
        }}
        onSubmit={(values) => {
          dispatch(
            updateAssetFeatureOptionSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          PicklistOptionName: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DamageDefinitionId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Translates: Yup.array(
            Yup.object({
              PicklistOptionName: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "PicklistOptionName",
            label: t("Contract.DamageOption.OptionName").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default DamageOptionEditForm;
